import type { User } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useCurrentUser } = getCRUDHooks<User>({
  entityName: 'currentUser',
  get: async () => {
    try {
      const response = await clientApi.getOCClient().helpers.user.me.get();
      return { body: response.body };
    } catch {
      return { body: null };
    }
  },
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useCurrentUser,
};
